import type { DetailedHTMLProps, IframeHTMLAttributes } from 'react';

interface ZeffyIframeInterface extends 
  DetailedHTMLProps<IframeHTMLAttributes<HTMLIFrameElement>, 
  HTMLIFrameElement> {
    allowPaymentRequest: boolean;
}

// export default function ZeffyIframe({allowPaymentRequest = true, ...props} : ZeffyIframeInterface): React.FC<ZeffyIframeInterface> {
//   return (
//       <iframe 
//         allowPaymentRequest={allowPaymentRequest}
//         {...props} 
//       />
//     )
// }

export const ZeffyIframe: React.FC<ZeffyIframeInterface> = (props: ZeffyIframeInterface) => {
  return (
      <iframe 
        {...props} 
      />
    )
}